module.exports = __webpack_public_path__ + "img/case3.d6f84dfe.jpg";